export function formatApkSize(bytes: number | null | undefined): string | null {
	if (bytes == null || !Number.isFinite(bytes) || bytes < 0) {
		return null;
	}

	const mb = bytes / (1024 * 1024);
	if (mb >= 0.1) {
		return `${mb.toLocaleString('ru-RU', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} МБ`;
	}

	const kb = bytes / 1024;
	if (kb >= 1) {
		return `${Math.round(kb).toLocaleString('ru-RU')} КБ`;
	}

	return `${bytes} Б`;
}
